export function getNexusChatRole(cemUser: unknown): 'Admin' | 'User' {
  if (typeof cemUser !== 'object' || cemUser === null || !('application' in cemUser)) return 'User';
  const applications = cemUser.application;
  if (!Array.isArray(applications)) return 'User';
  return applications.some((application: unknown) =>
    typeof application === 'object' && application !== null &&
    'role' in application && Array.isArray(application.role) &&
    application.role.includes('ChatBotAdmin'),
  ) ? 'Admin' : 'User';
}
